import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

// api
import { getMemoFromHearro, postMemoToHearro } from '../../../../services/apis/hearro/memo';


function HearroMemo() {
    const { pid } = useParams();
    const noteWrapperRef = useRef(null);

    const [memoData, setMemoData] = useState([]);
	const [isMemo, setIsMemo] = useState(false);
	const textAreaRef = useRef(null);
	const [newMemo, setNewMemo] = useState("");


    function writeMemo() {
        setIsMemo(true);
        textAreaRef.current.focus();
    }

    async function getMemoFromAPI() {
        try {
            const request = { pid }
            const res = await getMemoFromHearro(request);
            if(parseInt(res.status/200,10)===1){
                if(res.data.memoList){
                    setMemoData(res.data.memoList);
                }
                noteWrapperRef.current.scrollTo(0,99999);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
        }
    }

    async function saveMemo() {
        setIsMemo(false);

        if(!newMemo) {
            return;
        }

        try{
            const request = {
                pid,
                memoInfo: newMemo
            };
            const res = await postMemoToHearro(request);
            if(parseInt(res.status/200,10)===1){
               getMemoFromAPI();
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
            alert("메모 작성에 실패하였습니다.");
        }finally{
            setNewMemo("");
        }  
        textAreaRef.current.style.height = "auto";
    }


    useEffect(()=>{
        getMemoFromAPI();
    },[])

    useEffect(()=>{
        if(textAreaRef.current){
            const textAreaScrollHeight = textAreaRef.current.scrollHeight;
            if(textAreaScrollHeight){
                textAreaRef.current.style.height = `${textAreaScrollHeight}px`;
            }else {
                textAreaRef.current.style.height = "auto";
            }
        }
    },[newMemo, isMemo])

    return (
        <div className="patientResult__notesArea">
            <span className="notesTitle" style={{ marginBottom: '1rem'}}>memo</span>
            <div ref={noteWrapperRef} className="notesWrapper">
                <div className="notesContent">
                    {memoData.length>0 && memoData.map((item, idx) => (
                        <div key={idx} className="notes">
                            <div style={{ textAlign: 'left', whiteSpace: 'pre-line'}}>{item.info}</div>
                            <div style={{ textAlign: 'right'}}>- {item.modDate.split(" ")[0].replace(/-/g,'.')} -</div>
                        </div>
                    ))}
                    <div>
                        <textarea
                            className="notes__textarea"
                            ref={textAreaRef}
                            value={newMemo}
                            onChange={e => {
                                if (e.target.value.length > 2000) {
                                    e.target.value = e.target.value.slice(0, 2000);
                                }
                                setNewMemo(e.target.value);
                                e.target.style.height = "auto"; // Reset height to auto to recalculate
                                e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight
                            }}
                            readOnly={!isMemo}
                            maxLength={2000}
                        />
                    </div>
                </div>
            </div>
            {(newMemo &&  <div style={{textAlign:'right', fontSize: '0.8rem', color: '#888'}}>`{newMemo.length} / {textAreaRef.current?.maxLength}`</div>)}
            <div className="notesButtonWrapper">
                {isMemo === false ? (
                    <button className="cancelButton__rounded" onClick={writeMemo}>
                        작성
                    </button>
                ) : (
                    <button className="submitButton__rounded" onClick={saveMemo}>
                        저장
                    </button>
                )}
            </div>
        </div>
    );
}

export default HearroMemo;